import { render, staticRenderFns } from "./paginated.vue?vue&type=template&id=d1eff66e&"
import script from "./paginated.vue?vue&type=script&lang=js&"
export * from "./paginated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports